import { getBreakpoint } from './breakpoint'
import { reactive } from 'vue'

const store = reactive({
    breakpoint: getBreakpoint(),
    windowHeight: window.innerHeight,
    windowWidth: window.innerWidth,
})

export default store
